import { render, staticRenderFns } from "./SlidersAttendance.vue?vue&type=template&id=b1fa93a0"
import script from "./SlidersAttendance.vue?vue&type=script&lang=js"
export * from "./SlidersAttendance.vue?vue&type=script&lang=js"
import style0 from "./SlidersAttendance.vue?vue&type=style&index=0&id=b1fa93a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports